export default "__VITE_ASSET__2a49f7fb__"